export const APP_FETCH_STARTED = 'APP_FETCH_STARTED';
export const APP_FETCH_ERROR = 'APP_FETCH_ERROR';
export const APP_FETCH_SUCCESS = 'APP_FETCH_SUCCESS';
export const OPEN_PASSWORD_MODAL = 'OPEN_PASSWORD_MODAL';
export const CLOSE_PASSWORD_MODAL = 'CLOSE_PASSWORD_MODAL';
export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION';
export const POP_NOTIFICATION = 'POP_NOTIFICATION';

export const USER_LOGIN = 'POST:/user/login';
export const USER_LOGIN_GUEST = 'POST:/user/login/guest';
export const USER_LOGOUT = 'GET:/user/logout';
export const USER_IS_LOGGED_IN = 'GET:/user/isLoggedIn';
export const USER_CHANGE_PASSWORD = 'POST:/password';
export const MFA_SUBMIT_EMAIL = 'POST:/mfa/email';
export const MFA_SUBMIT_CODE = 'POST:/mfa/code';

export const STATE_ABBR = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];
